import type { ReplacementPair } from '@catch/libs';
import { Component, input } from '@angular/core';
import { QuillViewComponent } from 'ngx-quill';
import { ResolvePlaceholdersPipe } from '../../resolve-placeholders.pipe';

@Component({
  selector: 'ct-lib-markdown-viewer',
  templateUrl: './markdown-viewer.component.html',
  styleUrls: ['./markdown-viewer.component.scss'],
  animations: [],
  imports: [QuillViewComponent, ResolvePlaceholdersPipe],
})
export class MarkdownViewerComponent {
  value = input.required<string>();
  /** When set, `§…§` tokens in the HTML are replaced for preview (e.g. mail placeholders). */
  replacements = input<ReplacementPair | null>(null);
}